// Swedish

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `öppen fram till ${date}` : ''),
    },
    interview: {
      title: 'Besvara videointervjun',
      submit: 'Skicka svaren och slutför intervjun',
      continueLater: 'Fortsätt senare',
      startInterview: 'Börja intervjun',
      duplicateError: 'Du har redan deltagit i denna intervju. Du har fått ett e-postmeddelande från invitations@recright.com som innehåller en länk som kan användas för att fortsätta intervjun.',
      confirmSubmitHeader: 'Du har inte besvarat alla intervjufrågor',
      confirmSubmitContent: 'Vill du verkligen vill avsluta intervjun?',
      confirmSubmitContentWarning: 'Efter detta kan du inte slutföra dina svar.',
      submitInterviewHeader: 'Skicka in dina intervjusvar',
      submitInterviewContent: 'Är du säker på att du vill skicka in din intervju?',
      confirmSubmitButton: 'Skicka svar och slutför intervjun',
      preview: 'Här kan du förhandsgranska videofrågorna.',
      requiredQuestionsNotAnswered: 'Vänligen svara på alla obligatoriska frågor innan du skickar svaren.',
      withdrawLink: 'Inte intresserad av den här positionen längre? Avbryt processen här.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Namn',
      email: 'E-postadress',
      phone: 'Telefonnummer',
      city: 'Stad',
      link: 'Länk',
      legendBasicInfo: 'Grundläggande information',
      placeholderName: 'Ange ditt namn',
      placeholderEmail: 'Ange din e-postadress',
      placeholderPhone: 'Ange ditt telefonnummer',
      placeholderCity: 'Fyll i din nuvarande hemstad',
      placeholderLink: 'Ange länk',
      legendAttachments: 'Bilagor',
      legendAdditionalFields: 'Tilläggsinformation',
      required: '* Fälten markerade med en asterisk är obligatoriska.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Ljud',
        video: 'Video',
        yes: 'Ja',
        no: 'Nej',
        supported: 'Stöds',
        quality: 'Kvalitet',
        header: 'Nätverksanslutning och enhetstest',
        description: 'Nu kör vi ett test för att se till att din nätverksanslutning och hårdvara som behövs för intervjun (kamera och telefon) fungerar korrekt. Säkerställ att du tillåtit testet att använda kameran och mikrofonen vid uppmaning och säkerställ att kameran inte är täckt. Testet tar ungefär 30 sekunder.Vi rekommenderar att du talar under testet av hårdvaran',
        inProgress: 'Testet pågår...',
        networkTestResults: 'Resultaten av testet för nätverksanslutningen',
        qualityTestResults: 'Resultaten av testet för kvaliteten',
        testPassedQuality: 'Kvalitetstestet godkänt',
        testFailedQuality: 'Kvalitetstest misslyckades',
        testPassedNetwork: 'Nätverkstest klarat',
        testFailedNetwork: 'Nätverkstestet underkänt',
        startTest: 'Påbörja testet',
        startInterview: 'Påbörja intervjun',
        testAgain: 'Testa igen',
        confirmWarning: 'När din videointervju börjar förflyttas du automatiskt till din första intervjufråga. När du har sett frågan kommer du att förflyttas till förberedelsen.',
        confirmTitle: 'Du håller på att påbörja intervjun',
        confirmText: 'Du har en kort stund på dig att förbereda ditt svar innan varje fråga. Efter förberedelsen har du en förutbestämd tid på dig att besvara frågan. Observera att du kan skicka in ditt svar så snart du är klar, även innan den förutbestämda tiden har löpt ut.',
        confirmText2: 'Då du skickat in ditt svar flyttas du till nästa fråga tills det inte finns fler frågor',
        confirmText3:
          'Vänligen observera att du efter att du spelat in ditt svar har 30 sekunder på dig att spela in svaret på nytt, förutsatt att omtagningar är tillåtna. Om du inte startar omtagningen inom 30 sekunder kommer ditt nuvarande svar att skickas in automatiskt och du kommer att fortsätta till nästa fråga.',
        goodLuck: 'Ta ett djupt andetag så går det bra. Lycka till!',
        qualityRating: {
          excellent: 'Utmärkt',
          good: 'Bra',
          fair: 'Nöjaktig',
          poor: 'Svag',
          bad: 'Dålig',
        },
      },

      questionAnswerView: {
        title: title => `Svara på intervjun ${title}`,
        question: 'Fråga',
        submitAndNext: 'Skicka och nästa',
        submitSuccess: 'Videon skickades framgångsrikt!',
        skipText: 'Påbörja inspelningen',
        stop: 'Stoppa',
        submitAndFinish: 'Skicka in och avsluta intervjun',
        retake: 'Gör om',
        take: 'Tagning',
        takesLeft: 'Återstående tagningar',
        skipTextQuestion: 'Redo? Gå framåt',
        retakeConfirmTitle: 'Är du säker på att du vill svara på nytt på den här frågan?',
        retakeConfirmSubmit: 'Ja, starta omtagningen',
        submitInfoForward: 'Skickar in ditt nuvarande svar automatiskt och fortsätter vidare inom',
        submitInfoForward2: 'sekunder',
        nonAnswerableText: 'Detta meddelande kräver inget svar. Efter detta meddelande kommer du att tas direkt till nästa fråga.',
        nonAnswerableVideo: 'Den här videon kräver inget svar. Efter den här videon kommer du att tas direkt till nästa fråga.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Du har ${answerMinutes} minuter och ${answerSeconds} sekunder på dig att svara på frågan.`,
      },

      publisher: {
        toNextQuestion: timer => `Flyttas till nästa fråga ${timer}`,
        recordingStarts: timer => `Inspelningen påbörjas om ${timer}`,
      },

      errors: {
        tooManyConnections: 'Denna förbindelse stängdes för att du redan har en förbindelse öppen i en annan flik eller ett annat fönster.',
        unsupportedBrowser: 'Tyvärr stöds inte denna åtgärd i din webbläsare',
        networkError: 'Internetanslutning saknas ',
        reconnecting: 'Anslutningen avbröts. Försöker återansluta',
        generalError: 'Något gick fel. Uppdatera sidan och försök igen',
        allowMediaDevicesError: 'Åtgärden kunde inte koppla till medianeheter (kamera eller mikrofon). Vänligen säkerställ att du tillåtit webbläsaren användningen av kamera och mikrofon.',
        noAvailableDevicesError: 'Vi kunde inte hitta en kamera eller mikrofon. Försäkra dig om att webbläsaren har tillgång till din kamera och mikrofon och att ingen annan applikation använder dem just nu. Prova därefter på nytt.',
        initPublisherError: 'Åtgärd misslyckades på grund av ett fel. Kontrollera att du tillåtit webbläsaren att använda din kamera och mikrofon och att dessa inte används av ett annat program och försök igen.',
      },

      browserInfo: {
        browserSupportTitle: 'Webbläsarsupport',
        supportedBrowsers: 'Det här testet och intervjun stöder de senaste versionerna av Chrome, Firefox, Safari och Edge.',
        mobileSupported: 'Webbläsare som stöds på mobilenheter',
        android: 'Android: Google Chrome (senaste versionen), Firefox (senaste versionen)',
        iOS: 'iOS: Safari (senaste versionen)',
        latestVersion: 'Se till att du använder den senaste versionen av webbläsaren. Detta för att säkerställa att allt fungerar smidigt.',
        freezeInstruction: 'Om videoinspelningen inte startar eller inspelningsskärmen förblir svart, uppdatera sidan.',
        unsupportedOnIos: 'Det verkar som om du använder en webbläsare som inte stöds på iOS. Vänligen använd Safari.',
        ieUnsupported: 'Det verkar som om du använder Internet Explorer. Tyvärr stöds inte Internet Explorer webbläsaren för det här testet eller intervjun. Vänligen använd en annan webbläsare.',
        qualityTestNotSupported: 'Tyvärr stöds inte testet av hårdvaran i webbläsaren du använder. Du kan fortsätta till intervjun utan att testa ljud- och videokvaliteten, eller alternativt använda en annan webbläsare.',
      },
      reconnectSuccess: 'Återanlsutningen lyckades!',
      continue: 'Fortsätt',
    },

    withdraw: {
      title: 'Inte intresserad av den här positionen längre?',
      description: 'Avbryt rekryteringsprocessen för dig.',
      buttonText: 'Avbryt rekryteringsprocessen',
      thankYouTitle: 'Tack!',
      thankYouText: 'Du har nu informerat rekryterare om att du inte längre är intresserad av positionen.',
      confirm: 'Är du säker på att du avbryta rekryteringsprocessen? Efter avbrytandet kan du inte längre svara på denna intervju eller någon annan intervju som är relaterad till denna position.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Sänd',
      continue: 'Fortsätt',
      supportCenter: 'Recright Onlinesupport',
      thankYou:
        'Tack för ditt video svar! Vi kommer att vara i kontakt med dig inom kort!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Tack för att du deltog i intervjun!',
      reopenDescription: 'Om du stängde denna intervju av misstag – ingen fara! Du kan öppna intervjun igen genom att klicka på knappen nedan!',
      reopenButtonText: 'Öppna intervjun igen',
      description1: 'Bra, du har svarat på alla frågor och dina svar har skickats vidare.',
      descriptionsupport: mailto => `Om du har slutfört den här intervjun av misstag, kontakta vår kundtjänst   ${mailto} så att vi kan öppna din intervju pånytt.`,
      descriptionfeedback: 'Lämna din feedback via denna länk.',
      feedbackbutton: 'Lämna feedback till oss',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Personligt meddelande',
    },

    closed: {
      title: 'Intervjun är över',
      description: 'Videointervjun som du blivit inviterad till är över.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: ' Din videointervju har sparats!',
      description: 'Dina svar finns sparade i intervjun. Du kan återkomma till din personliga intervju via länken som tidigare skickats till din email. Lycka till med arbetsintervjun!',
      remember: 'Kom ihåg att skicka svaren till rekryteraren när du är klar med intervjun.',
      deleteHistory: 'Ifall du gör intervjun på en allmän dator, kom ihåg att radera webbläsarens historik. Med hjälp av detta håller du din intervju skyddad från övriga användare.',
    },
    unpublished: {
      title: 'Intervjun är inte öppen ännu',
      publishTime: publishTime => `Intervjun öppnas ${publishTime}`,
    },
  },
}
